// Global
import React from 'react';

// Local
import styles from './FooterBottomBar.module.scss';
import { PureFooterBottomBar } from '../types';

type Props = {
  pureFooterBottomBar?: PureFooterBottomBar;
};

const FooterBottomBar: React.FC<Props> = ({ pureFooterBottomBar }) => {
  if (pureFooterBottomBar?.links.length === 0) {
    return null;
  }

  const renderLinks = () => {
    return pureFooterBottomBar?.links.map((footerLink, index) => {
      return (
        <li key={index} className={styles.linkListItem}>
          {footerLink.link}
        </li>
      );
    });
  };

  return (
    <div className={styles.footerBottomBarWrapper}>
      <div className={styles.footerBottomBar}>
        <nav
          aria-label={pureFooterBottomBar?.bottomNavigationLabel}
          className={styles.bottomBarNav}
        >
          <ul className={styles.bottomBarLinks}>{renderLinks()}</ul>
        </nav>

        <div className={styles.copyrightText}>{pureFooterBottomBar?.copyrightText}</div>
      </div>
    </div>
  );
};

export default FooterBottomBar;
